import React, { Component } from 'react';
import { Grid, GridColumn as Column} from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import Loader from '../../integration/components/Loader';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import { getPMResourceList, getPMTimeEntries, approvePMTimeEntries, rejectPMTimeEntries } from './TimeSheetApprovalService';
import { getRegions} from '../../masterData/region/RegionService';
import { getPMResources } from '../../resourceManagement/ResourceService';
import { saveAuditTrail } from '../../integration/auditTrail/AuditTrailService';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import * as loggerService from '../../integration/LoggerService';
import { LOG_TYPES } from '../../integration/IntegrationEnums';
import moment from 'moment';
import 'moment-timezone';

class PMTimeApproval extends Component {
    isMount = false;
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            pmResourceList: [],
            newDatePM: new Date(),
            firstDayOfWeekPM: null,
            lastDayOfWeekPM: null,
            projectRegions: [],
            projectRegionsAll: [],
            validRegions: [],
            selectedProjectRegion: null,
            pmResources: [],
            pmResourcesAll: [],
            selectedPMResource: null,
            selectedResources: [],
            visible: false,
            dialogTitle: '',
            dialogMessage: '',
            showSuccessImage: false,
            showErrorImage: false,
            rejectReason: '',
            isErrorMessageVisible: false
        };
    }

    async componentDidMount() {
        this.isMount = true;
        this.props.onHeaderTitleChange('PM Timesheet Approval');
        await this.populateInitialData();
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    populateInitialData = async () => {
        await this.setState({
            loading: true
        });
        await this.populateProjectRegions();
        await this.validateRegions();
        await this.populatePMResources();
        await this.setWeekDatesPM(new Date());
        await this.onSaveAuditTrail();
        await this.setState({
            loading: false
        });
    }

    onSaveAuditTrail = async() => {
        if (this.isMount) {
            const auditTrail = {
                Action: 'PM Time Sheet Approval viewed',
                RefType: 'Time Sheet Approval',
                RefId: window.LOGGED_USER.user,
                RefName: window.LOGGED_USER.displayName
            }
            await saveAuditTrail(auditTrail);
        }
    }

    populateProjectRegions = async () => {
        await getRegions().then(res => {
            if (this.isMount) {
                this.setState({
                    projectRegions: res.data,
                    projectRegionsAll: res.data,
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };
    
    populatePMResources = async () => {
        await getPMResources().then(res => {
            if (this.isMount) {
                this.setState({
                    pmResources: res.data,
                    pmResourcesAll: res.data,
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    validateRegions = async() => {
        let validRegions = [];
        const userPermissions = window.USER_PERMISSION;

        const globalPermission= userPermissions.some(obj => obj === 'APRV_TM_SHT_GLBL');
        if (globalPermission) {
            await this.setState({
                validRegions: this.state.projectRegionsAll
            });
        } else {
            const asiaPermission= userPermissions.some(obj => obj === 'AMEA_PM_TM_SHT');
            if (asiaPermission) {
                const asiaRegios = this.state.projectRegionsAll.filter(x => x.id === 3 || x.id === 5 || x.id === 17 || x.id === 18 || x.id === 19);
                validRegions = validRegions.concat(asiaRegios);
            }
    
            const anzPermission = userPermissions.some(obj => obj === 'ANZ_PM_TM_SHT');
            if (anzPermission) {
                const anzRegios = this.state.projectRegionsAll.filter(x => x.id === 4);
                validRegions = validRegions.concat(anzRegios);
            }
    
            const ukPermission = userPermissions.some(obj => obj === 'UK_EUROPE_PM_TM_SHT');
            if (ukPermission) {
                const ukRegios = this.state.projectRegionsAll.filter(x => x.id === 1 ||  x.id === 21);
                validRegions = validRegions.concat(ukRegios);
            }
    
            const usPermission = userPermissions.some(obj => obj === 'AMERICAS_PM_TM_SHT');
            if (usPermission) {
                const usRegios = this.state.projectRegionsAll.filter(x => x.id === 2);
                validRegions = validRegions.concat(usRegios);
            }
    
            if (validRegions && validRegions.length > 0) {
                await this.setState({
                    projectRegions:validRegions,
                    selectedRegion: validRegions,
                    validRegions: validRegions,
                });
            }    
        }
    };

    cancelSearch = () => {
        this.setState({
            selectedProjectRegion: null,
            selectedPMResource: null,
        });
    }

    getPMResourceList = async(e) => {
        if (e) {
            e.preventDefault();
        }

        await this.setState({
            loading: true,
            pmResourceList: []
        });

        const params = {
            firstDate: moment(this.state.firstDayOfWeekPM).format('YYYY-MM-DD'),
            lastDate: moment(this.state.lastDayOfWeekPM).format('YYYY-MM-DD'),
            validRegions: this.state.selectedProjectRegion && this.state.selectedProjectRegion.length > 0 ? this.state.selectedProjectRegion : this.state.validRegions,
            selectedResource: this.state.selectedPMResource,
            approver: window.USER_PERMISSION.indexOf('APRV_TM_SHT_GLBL') > -1 ? 'GlobleApprover' : 'genaralApprover',
            approverId: window.LOGGED_USER.user,
        };
        await getPMResourceList(params).then(res => {
            this.setState({
                pmResourceList: res.data,
                loading: false,
            });
        }).catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    getPMTimeEntries = async (userId) => {
        if (userId) {
            await this.setState({
                loading: true,
            });

            const fields = {
                selectedResource: [userId],
                firstDate: moment(this.state.firstDayOfWeekPM).format('YYYY-MM-DD'),
                lastDate: moment(this.state.lastDayOfWeekPM).format('YYYY-MM-DD'),
                validRegions: this.state.validRegions,
                approver: window.USER_PERMISSION.indexOf('APRV_TM_SHT_GLBL') > -1 ? 'GlobleApprover' : 'genaralApprover',
                approverId: window.LOGGED_USER.user,               
            };        

            await getPMTimeEntries(fields).then(async res => {
                if (this.isMount) {
                    let pmResourceList = this.state.pmResourceList;
                    let objIndex = pmResourceList.findIndex(obj => obj.userId === userId);
                    pmResourceList[objIndex].TimeEntryTasks = res.data.TimeEntryTasks;
                    await this.setState({
                        pmResourceList: pmResourceList,
                        loading: false,
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
        }

        await this.setState({
            loading: false
        });
    }

    prevWeekPM = () => {
        const date = this.state.newDatePM;
        const newDate = new Date();
        const prevWeek = new Date(
            newDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate() - 7)
        );
        this.setState({
            newDatePM: prevWeek,
            pmResourceList: []
        },() => 
            this.setWeekDatesPM(prevWeek)
        );
    };

    nextWeekPM = () => {
        const date = this.state.newDatePM;
        const newDate = new Date();
        const nextWeek = new Date(
            newDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate() + 7)
        );
        this.setState({
            newDatePM: nextWeek,
            pmResourceList: []
        },() => {
            this.setWeekDatesPM(nextWeek)
        });
    };

    setWeekDatesPM = async (date) => {
        if (date !== null) {
            let firstDayOfWeek = null;
            let lastDayOfWeek = null
            if (moment(date).day() !== 0) {
                // Monday as first day, Sunday as last day
                firstDayOfWeek = moment(date).startOf('week').add(1, 'days').toDate(); // Monday
                lastDayOfWeek = moment(date).startOf('week').add(7, 'days').toDate();  // Sunday
            } else {
                // If Sunday, week is previous 6 days + this Sunday
                firstDayOfWeek = moment(date).subtract(6, 'days').toDate();
                lastDayOfWeek = moment(date).toDate();
            }
    
            await this.setState({
                newDatePM: date,
                firstDayOfWeekPM: firstDayOfWeek,
                lastDayOfWeekPM: lastDayOfWeek,
                pmResourceList: []
            },
            async () => {
                await this.getPMResourceList();
            });
        }
    };
    
    setTotalOfWeek = times => {
        let durationParts = times.toString().split('.');
        let duration = durationParts[0];
        let durMinPart = this.roundUp(durationParts[1],1)
        .toString()
        .padStart(2, '0');
        if (typeof durationParts[1] !== 'undefined') {
            if(parseInt(durMinPart) === 60){
                duration = parseInt(duration) + 1;
                durMinPart = '00';
            }else{
                durMinPart = this.roundUp(durationParts[1],1).toString().padStart(2, '0');;
            }
            duration =
                parseInt(duration) +
                ':' +
                durMinPart;
            return duration;
        } else {
            return (duration = parseInt(duration));
        }
    };

    setTimeFormat = time => {
        if (time) {
            let durationParts = time.toString().split('.');
            let duration = durationParts[0];
            let durMinPart = this.roundUp(durationParts[1],1)
            .toString()
            .padStart(2, '0');
            if (typeof durationParts[1] !== 'undefined') {
                if(parseInt(durMinPart) === 60){
                    duration = parseInt(duration) + 1;
                    durMinPart = '00';
                }else{
                    durMinPart = this.roundUp(durationParts[1],1).toString().padStart(2, '0');;
                }
                duration =
                    parseInt(duration) +
                    ':' + durMinPart
                return duration;
            } else {
                duration = parseInt(duration) + ':' + '00';
                return duration;
            }
        }
    };

    roundUp = (num, precision) => {
        num = parseFloat(`0.${num}`) * 60;
        num = num.toFixed(2) / 10;
        precision = Math.pow(10, precision);
        return (Math.ceil(num * precision) / precision) * 10;
    };

    filterProjectRegions = event => {
        if (this.isMount) {
            this.setState({
                projectRegions: this.filterData(event.filter, this.state.validRegions)
            });
        }
    };

    filterPMResources = event => {
        if (this.isMount) {
            this.setState({
                pmResources: this.filterData(event.filter, this.state.pmResourcesAll)
            });
        }
    };

    filterData(filter, allData) {
        const data = allData.slice();
        return filterBy(data, filter);
    }

    handleInputChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    resourceClickHandler = async (userId) => {
        let allData = this.state.pmResourceList;
        const newData = allData.filter(x => x.userId === userId)[0];
        newData.selected = !newData.selected;

        const selected = await this.state.pmResourceList.filter(resource => resource.selected === true);

        await this.setState({
            selectedResources: selected
        });
    };

    onClickApprove = async() => {
        if (this.state.selectedResources && this.state.selectedResources.length === 0) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true
            });
            this.toggleDialog('No selected user(s)', 'Error');
        } else {
            await this.setState({
                loading: true,
            });
            const approveObj = {
                selectedResources: this.state.selectedResources ? this.state.selectedResources : [],
                firstDate: moment(this.state.firstDayOfWeekPM).format('YYYY-MM-DD'),
                lastDate: moment(this.state.lastDayOfWeekPM).format('YYYY-MM-DD'),
                approver: window.USER_PERMISSION.indexOf('APRV_TM_SHT_GLBL') > -1 ? 'GlobleApprover' : 'genaralApprover',
                approverId: window.LOGGED_USER.user,
                validRegions: this.state.validRegions,
            };        
            await approvePMTimeEntries(approveObj)
            .then(async res => {
                this.setState({
                    selectedResources: [],
                });
                await this.getPMResourceList();
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
            await this.setState({
                loading: false,
            });
        }
    };

    onClickReject = async() => {
        if (
        this.validateProperty(this.state.rejectReason)
            .toString()
            .includes('error')
        ) {
            this.setState({
                isErrorMessageVisible: true
            });
        } else {
            if (this.state.selectedResources && this.state.selectedResources.length > 0) {
                await this.setState({
                    loading: true,
                });
                const approveObj = {
                    selectedResources: this.state.selectedResources ? this.state.selectedResources : [],
                    firstDate: moment(this.state.firstDayOfWeekPM).format('YYYY-MM-DD'),
                    lastDate: moment(this.state.lastDayOfWeekPM).format('YYYY-MM-DD'),
                    approver: window.USER_PERMISSION.indexOf('APRV_TM_SHT_GLBL') > -1 ? 'GlobleApprover' : 'genaralApprover',
                    approverId: window.LOGGED_USER.user,
                    validRegions: this.state.validRegions,
                    rejectReason: this.state.rejectReason
                };        
                await rejectPMTimeEntries(approveObj)
                .then(async res => {
                    this.setState({
                        rejectTa: false,
                        selectedResources: [],
                    });
                    await this.getPMResourceList();
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });
                await this.setState({
                    loading: false,
                });
            }
        }
    };

    toggleRejectDialog = () => {
        if (this.state.selectedResources && this.state.selectedResources.length === 0) {
            this.setState({
                showSuccessImage: false,
                showErrorImage: true
            });
            this.toggleDialog('No selected user(s)', 'Error');
        } else {
            this.setState({
                rejectTa: !this.state.rejectTa,
                rejectReason: null,
                isErrorMessageVisible: false
            });
        }
    }

    rejectReasonHandler = e => {
        this.setState({
            rejectReason: e.target.value
        });
    };

    validateProperty = value => {
        if (value) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    toggleDialog = (message, title) => {
        this.setState({
            visible: !this.state.visible,
            dialogMessage: message,
            dialogTitle: title
        });
    };

    render() {
        return (
        <div className="main-card">
            <div className="row">
                <div className="col-md-8">
                    <div className="main-heading">PM Timesheet Approval</div>
                </div>
            </div>

            <form onSubmit={this.getPMResourceList}>
                <div className="row">
                    <div className="col-md-3">
                        <label className="">Project Region:</label>
                        <MultiSelect  
                            data={this.state.projectRegions}
                            name="selectedProjectRegion"
                            textField="Name"
                            placeholder={'Please Select'}
                            onChange={this.handleInputChange}
                            value={this.state.selectedProjectRegion}
                            filterable={true}
                            onFilterChange={this.filterProjectRegions}
                        />
                    </div>
                    <div className="col-md-3">
                        <label className="">Resource:</label>
                        <MultiSelect  
                            data={this.state.pmResources}
                            name="selectedPMResource"
                            textField="Name"
                            placeholder={'Please Select'}
                            onChange={this.handleInputChange}
                            value={this.state.selectedPMResource}
                            filterable={true}
                            onFilterChange={this.filterPMResources}
                        />
                    </div>
                </div>

                <div className="row"></div>

                <div className="row">
                    <div className="col-md-12 btn-align-right">
                    <Button primary={true} type="button" onClick={this.getPMResourceList}>
                        Search
                    </Button>
                    <Button type="button" onClick={this.cancelSearch}>
                        Clear
                    </Button>
                    </div>
                </div>
            </form>

            <div className="main-seperator" />

            <div className="panel-toolbar mt-3 px-2 py-2 fade-in">
                <div className="row ">
                    <div className="col-md-3 d-flex align-items-center">
                        <label className="mr-2">Date: </label>
                        <DatePicker
                            defaultValue={new Date()}
                            format="MM/dd/yyyy"
                            min={new Date('01/01/2021')}
                            formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                            value={this.state.newDatePM}
                            onChange={event => this.setWeekDatesPM(event.target.value)}
                        />

                        <div className="d-flex">
                            <a
                                type="button"
                                onClick={() => this.prevWeekPM()}
                            >
                                <div className="rounded-link d-flex align-items-center justify-content-center mr-2 ml-2">
                                <span className="k-icon k-i-arrow-chevron-left" />
                                </div>
                            </a>

                            <a type="button" onClick={() => this.nextWeekPM()}>
                                <div className="rounded-link d-flex align-items-center justify-content-center mr-2">
                                <span className="k-icon k-i-arrow-chevron-right" />
                                </div>
                            </a>
                        </div>
                    </div>

                    <div className="col-md-9 btn-align-right">
                        <Button
                            primary={true}
                            onClick={this.toggleRejectDialog}
                            >
                            Reject
                        </Button>
                        <Button
                            primary={true}
                            onClick={() => this.onClickApprove()}
                        >
                            Approve
                        </Button>
                    </div>
                </div>
            </div>

            <div className="row window-ta fade-in approval-weekly-panel-wrap">
                <div className="col-md-12 panel-dark">
                {this.state.pmResourceList.length !== 0 &&
                    this.state.pmResourceList.map(resource => (
                    <PanelBar
                        onSelect={e => {
                            this.getPMTimeEntries(resource.userId);
                        }}
                        className="mt-2"
                        key={resource.userId}
                    >
                        <input
                            type="checkbox"
                            className="k-checkbox mr-2 time-approval-panel-checkbox"
                            name="resourcename"
                            checked={resource.selected}
                            onChange={() => this.resourceClickHandler(resource.userId)}
                        />
                        <PanelBarItem
                            aniamation={true}
                            expanded={this.state.allPanelExapnded}
                            title={
                                <div className="font-weight-bold" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                                    <div>                           
                                        <label className="reso-name ml-4">Resource : {resource.Name} </label>
                                        {parseInt(
                                            this.setTotalOfWeek(resource.totalOfWeek)
                                            .toString()
                                            .split(':')[0]
                                        ) >= 40 ? (
                                            <span className="resc-green ml-3">
                                            { this.setTotalOfWeek(resource.totalOfWeek) + ' Hours '} / 40 Hours
                                            </span>
                                        ) : (
                                            <span className="resc-red ml-3">
                                            {this.setTotalOfWeek(resource.totalOfWeek) + ' Hours '} / 40 Hours
                                            </span>
                                        )}
                                    </div>
                                    <div>
                                        <label className="mr-4">Status : {resource.dhApprovalStatus}</label>
                                    </div>
                                </div>
                            }
                        >
                        <div className="row fade-in">
                            <div className="col-md-12">
                            <Grid
                                selectedField="selected"
                                onHeaderSelectionChange={this.headerSelectionChange}
                                data={resource.TimeEntryTasks}
                                sortable={true}
                                className="time-approval-grid-allpending"
                            >
                                <Column field="selected" width="25px" />
                                <Column field="ApprovalStatus"  title="Approval Status" />
                                <Column field="ProjectNonProjectTaskGroup" title="Project/Task Group" />
                                <Column field="Task" title="Task" />
                                <Column 
                                    field="SumOfResourceEnteredDuration" 
                                    title="Sum of Resource Entered Duration" 
                                    cell={props => (props.dataItem.SumOfResourceEnteredDuration !== null ? 
                                        <td>{this.setTimeFormat(props.dataItem.SumOfResourceEnteredDuration)}</td> : 
                                        <td>{''}</td>
                                    )}
                                />
                                <Column 
                                    field="SumOfApprovedDuration" 
                                    title="Sum of Approved Duration"
                                    cell={props => (props.dataItem.SumOfApprovedDuration !== null ? 
                                        <td>{this.setTimeFormat(props.dataItem.SumOfApprovedDuration)}</td> : 
                                        <td>{''}</td>
                                    )}
                                />
                                <Column field="ApprovalStatusDH" title="Delivery Head Approval Status" />
                            </Grid>
                            </div>
                        </div>
                        </PanelBarItem>
                    </PanelBar>
                    ))}
                {this.state.pmResourceList.length === 0 && (
                    <div className="no-record-wrap">No records available</div>
                )}
                </div>
            </div>

            {this.state.visible === true && (
                <Dialog title={this.state.dialogTitle} onClose={this.toggleDialog} width="400px">
                    {this.state.showSuccessImage === true && (
                        <div className="text-center">
                        <img className="successImg" src={SuccessImg} alt="Success" />
                        </div>
                    )}
        
                    {this.state.showErrorImage === true && (
                        <div className="text-center">
                        <img className="successImg" src={ErrorImg} alt="Error Image" />
                        </div>
                    )}
                    <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>
    
                    <DialogActionsBar>
                        <button className="k-button modal-primary" onClick={this.toggleDialog}>
                            OK
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}

            {this.state.rejectTa && (
                <Dialog
                    title={'Reason for Timesheet Rejection'}
                    onClose={this.toggleRejectDialog}
                    width={400}
                >
                <div className="row">
                    <div className="col-md-3">
                        <div className="d-block">
                            <label className="mandatory">Reason:</label>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="d-block">
                            <textarea
                            className="k-textarea"
                            onChange={this.rejectReasonHandler}
                            maxLength={100}
                            />
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.rejectReason)}>
                                    Reason is mandatory
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
                    <DialogActionsBar>
                        <button className="k-button " onClick={this.toggleRejectDialog}>
                            Cancel
                        </button>
                        <button className="k-button modal-primary" onClick={() => this.onClickReject()}>
                            Reject
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}

            <Loader loading={this.state.loading} />

        </div>
        );
    }
}

export default PMTimeApproval;



